import { useEffect } from "react";

const setMeta = (selector, attribute, value) => {
  const tag = document.head.querySelector(selector);
  if (tag) tag.setAttribute(attribute, value);
};

// Sets the per-route title, description and canonical URL. The canonical link
// is only ever added here (not in public/index.html) so each route ends up with
// exactly one, as Google recommends for client-rendered pages.
const usePageMeta = ({ title, description, canonical }) => {
  useEffect(() => {
    document.title = title;
    setMeta('meta[name="description"]', "content", description);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);
  }, [title, description, canonical]);
};

export default usePageMeta;
